import React from "react";
import { getIn } from "formik";
import { FontColors } from "theme/fontConfig";

const FieldErrorMessage = ({ formik, name, ...rest }) => {
  const error = getIn(formik.errors, name);
  const touched = getIn(formik.touched, name);

  if (!touched || !error) return null;

  return (
    <div className="fv-plugins-message-container" {...rest}>
      <div className="fv-help-block" style={{ color: FontColors.Red }}>
        {error}
      </div>
    </div>
  );
};

export default FieldErrorMessage;
